import React, { useState, useEffect, useCallback } from "react";
import {
  MenuItem,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  Typography,
} from "@mui/material";
import "../../Pages/Masters/Roles and Permissions/Filters//Scrollbar.css";
import { get } from "../../utils/api";

const MultiSelect = ({
  title,
  options = [],
  label = "Select",
  onChange,
  url = null,
  errors,
  name,
  marginTop,
  value = [],
  placeholder = "Tap to select",
}) => {
  const normalizeIds = (v) => {
    if (v == null) return [];
    const arr = Array.isArray(v) ? v : [v];
    return arr
      .map((id) => (id != null && id !== "" ? String(id) : null))
      .filter(Boolean);
  };

  const [selectedOptions, setSelectedOptions] = useState(() =>
    normalizeIds(value)
  );
  const [fetchedOptions, setFetchedOptions] = useState([]);
  const fetchOptions = useCallback(() => {
    if (url) {
      get(url)
        .then((res) => {
          const data = res.data?.data || [];
          const formattedOptions = data.map((item) => ({
            value: String(item._id),
            label: item.name || item.equipment,
          }));
          setFetchedOptions(formattedOptions);
        })
        .catch((err) => console.error("Error fetching options:", err));
    }
  }, [url]);

  useEffect(() => {
    fetchOptions();
  }, [url, fetchOptions]);

  useEffect(() => {
    setSelectedOptions(normalizeIds(value));
  }, [value]);

  const handleLocalChange = (event) => {
    const selectedValues = event.target.value;
    const currentOptions = url ? fetchedOptions : options;

    if (selectedValues.includes("all")) {
      const prev = Array.isArray(selectedOptions) ? selectedOptions : [];
      const allSelected = prev.length !== currentOptions.length;
      const newSelected = allSelected
        ? currentOptions.map((opt) => opt.value)
        : [];
      setSelectedOptions(normalizeIds(newSelected));
      onChange({ name, value: normalizeIds(newSelected) });
    } else {
      setSelectedOptions(normalizeIds(selectedValues));
      onChange({ name, value: normalizeIds(selectedValues) });
    }
  };

  const availableOptions = url ? fetchedOptions : options;
  const safeSelected = Array.isArray(selectedOptions) ? selectedOptions : [];
  const isAllSelected =
    availableOptions.length > 0 &&
    safeSelected.length === availableOptions.length;

  return (
    <FormControl fullWidth>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: "bold",
          mt: name === "consumptionPeriod" ? marginTop || 0 : 1,
        }}
      >
        {title}
      </Typography>
      <Select
        multiple
        size="small"
        value={safeSelected}
        onChange={handleLocalChange}
        error={!!errors}
        displayEmpty
        renderValue={(selected) => {
          const sel = Array.isArray(selected) ? selected : [];
          if (sel.length === 0) {
            return <em>{placeholder}</em>;
          }
          return availableOptions
            ?.filter((option) => sel.includes(option.value))
            .map((option) => option.label)
            .join(", ");
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 400,
              width: "10%",
              overflowY: "auto",
              padding: 0,
              margin: 0,
            },
          },
        }}
      >
        <MenuItem value="all" sx={{ padding: 0 }}>
          <Checkbox checked={isAllSelected} />
          <ListItemText primary="Select All" />
        </MenuItem>
        {availableOptions?.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ padding: 0 }}>
            <Checkbox checked={safeSelected.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </FormControl>
  );
};

export default MultiSelect;
